import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { Redirect } from "react-router-dom";
import { LogoutUser } from '../../action/authenticateUser';


class Logout extends Component {

  constructor(props){
    super(props);
    this.state = {
      Logout : true,
    };
}

componentWillMount(){
  this.props.LogoutUser();
}

componentWillReceiveProps(nextProps) {
  // if (this.props != nextProps) {
  //   this.setState({ Logout: nextProps.authentication_response.loggedIn });
  // }
}


    render() {
      localStorage.setItem('jwt', null);
      localStorage.setItem('refreshjwt', null);

      return (

               <Redirect to="/facilitymanagementlogin" />
            );
      // if(this.state.Logout === false){
      //   console.log("testing")
      //   return <Redirect to={"/facilitylogin"} />
      // }
      //   return (
      //        <Redirect to="/facilitylogin" />
      //     );
    }
}


const mapStateToProps = state => {
  return {
    authentication_response: state.authService
  };
};

const mapDispatchToProps = dispatch => {
  return {
      LogoutUser: () => dispatch(LogoutUser()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Logout);



